import { useFavicon } from 'react-use';

export const CLOUDINARY_FAVICON =
  'https://res-s.cloudinary.com/cloudinary/image/upload/c_scale,fl_attachment,w_500/v1/logo/for_white_bg/cloudinary_icon_for_white_bg.png';
const useCloudinaryFavicon = () => useFavicon(CLOUDINARY_FAVICON);

export default useCloudinaryFavicon;
